const XTABLES_ACTION_TYPES = Object.freeze({
    SET_USER: "SET_USER",
    SET_ALLUSERS: "SET_ALLUSERS",
    SET_SELECTEDCELL_STATE:"SET_SELECTEDCELL_STATE",
    SET_VIEW: "SET_VIEW",
    SET_PREDECESSORCOLUMN_STATE:"SET_PREDECESSORCOLUMN_STATE",
    SET_STATUSCOLUMN_STATE : "SET_STATUSCOLUMN_STATE",
    SET_HIGHLIGHTING:"SET_HIGHLIGHTING",
    SET_GRIDCHANGESPERSESSION:"SET_GRIDCHANGESPERSESSION",
    ENABLE_SAVE_BUTTON:"ENABLE_SAVE_BUTTON",
    DISABLE_SAVE_BUTTON:"DISABLE_SAVE_BUTTON",
    SET_HIGHLIGHT_STACK:"SET_HIGHLIGHT_STACK",
    SET_FILTER_MODEL: "SET_FILTER_MODEL",
    CLEAR_FILTER_MODEL: "CLEAR_FILTER_MODEL",
    ENABLE_CARD_VIEW:"ENABLE_CARD_VIEW",
    SET_IS_UPDATING:'SET_IS_UPDATING',
    SET_CLONE_DATA_OF_ROWS: "SET_CLONE_DATA_OF_ROWS",
    ENABLE_CARD_VIEW:"ENABLE_CARD_VIEW",
    IS_FILTER_OR_SUMMARY_VIEW_ACTIVE:"IS_FILTER_OR_SUMMARY_VIEW_ACTIVE",
    SET_VIEW_CHANGING:"SET_VIEW_CHANGING",
    SET_LAST_SYNCED_TIMESTAMP:"SET_LAST_SYNCED_TIMESTAMP",
    SET_STATUS_COLS:"SET_STATUS_COLS",
    DELETE_STATUS_COL:"DELETE_STATUS_COL",
    RESET_STATUS_COLS:"RESET_STATUS_COLS",
    SET_OPERATIONINPROGRESS : "SET_OPERATIONINPROGRESS",
    INIT_CARD_VIEW: "INIT_CARD_VIEW",
    PATCH_CARD_AFTER_EDIT: "PATCH_CARD_AFTER_EDIT",
    DELETE_CARD_FROM_LANE_SUCCESS:"DELETE_CARD_FROM_LANE_SUCCESS",
    SAVE_CARD_VIEW_CHANGES:"SAVE_CARD_VIEW_CHANGES",
    UPDATE_CARD_IN_LANE_SUCCESS:"UPDATE_CARD_IN_LANE_SUCCESS",
    SET_GRIDCHANGESPERSESSION:"SET_GRIDCHANGESPERSESSION",
    SET_UPDATEROWS:"SET_UPDATEROWS"
    
})

export default XTABLES_ACTION_TYPES 